export { PlaceholderIcon as IngredientsNicotineIcon } from "./placeholder";
